<template>
  <div>
    <el-dialog title="用户封控记录" :visible.sync="dialogVisible" width="70%">
      <el-table :data="list" border style="width: 100%">
        <el-table-column prop="id" label="用户ID" width="100px" align="center">
          <template v-slot="scope">
            {{ scope.row.user_id }}
          </template>
        </el-table-column>
        <el-table-column prop="封控ID" label="类型" align="center">
          <template v-slot="scope">
            {{ scope.row.rule_id }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="处罚" align="center">
          <template v-slot="scope">
            {{ scope.row.type == 1 ? "警告" : "封禁" }}
          </template>
        </el-table-column>
        <el-table-column label="封控名称" align="center">
          <template v-slot="scope">
            <span v-if="scope.row.appRules">
              {{ scope.row.appRules.name }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="time" label="时间" align="center"
          ><template v-slot="scope">
            {{ scope.row.time || "无" }}
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" align="center">
        </el-table-column>
        <el-table-column prop="name" label="类别" align="center">
          <template v-slot="scope">
            {{
              scope.row.rule_type == 1
                ? "登入"
                : scope.row.rule_type == 2
                ? "拉广"
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="触发时间" align="center">
          <template v-slot="scope">
            {{ $fnc.getTimeFormat(scope.row.created_time, "ymdhms") }}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      dialogVisible: false,
    };
  },
  methods: {
    openDialog(user_id) {
      this.getList(user_id);
      this.dialogVisible = true;
    },
    async getList(id) {
      let data = await this.$api.getChannel.getUserTriggerRuleList({
        id,
      });
      this.list = data.data;
    },
  },
};
</script>

<style>
</style>